var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jotFormIFrame',{attrs:{"pageTitle":_vm.productName,"quoteObj":_vm.quoteObj}})}
var staticRenderFns = []

export { render, staticRenderFns }